import { CircleClockIcon } from '@spotahome/ui-library';

/*
  Position of the banner. 
  0 count as a position.
  This allows to include multiple banners to the HomeCardList component
*/
const bannerList = {
  3: {
    name: 'book-securely',
    Icon: CircleClockIcon,
    isActive: true,
    tracking: {
      eventCategory: 'Search',
      eventAction: 'informative-homecard',
      eventLabel: '24h-return'
    }
  }
};

const getNumberActiveBanners = () => {
  return Object.keys(bannerList).filter(
    bannerPosition => bannerList[bannerPosition].isActive
  ).length;
};

export default { bannerList, getNumberActiveBanners };
